module.exports = __webpack_public_path__ + "files/45e28b803cfadf24a887e6c5ee4e1b44.png";


//////////////////
// WEBPACK FOOTER
// ./images/emoji-sheets/flags-2.png
// module id = 1628
// module chunks = 60